function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M582 499q0 13-10 23L106 988q-10 10-23 10t-23-10l-50-50Q0 928 0 915t10-23l393-393L10 106Q0 96 0 83t10-23l50-50Q70 0 83 0t23 10l466 466q10 10 10 23z"
});

function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 582 998"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1ODIgOTk4Ij48cGF0aCBkPSJNNTgyIDQ5OXEwIDEzLTEwIDIzTDEwNiA5ODhxLTEwIDEwLTIzIDEwdC0yMy0xMGwtNTAtNTBRMCA5MjggMCA5MTV0MTAtMjNsMzkzLTM5M0wxMCAxMDZRMCA5NiAwIDgzdDEwLTIzbDUwLTUwUTcwIDAgODMgMHQyMyAxMGw0NjYgNDY2cTEwIDEwIDEwIDIzeiIvPjwvc3ZnPgo=";
export { SvgNext as ReactComponent };